export const FACEBOOK_APP_ID = '223007281654121';
export const GOOGLE_CLIENT_ID = '1031403893148-92d1gc1blise884pe62gab6vdld4rd81.apps.googleusercontent.com';

export default class QRQinectConstants {

}


// WEBPACK FOOTER //
// ./src/QRQinectConstants.js